import Generator from '../../Generator'
import Types from '../../../actions/Types'

export default Generator.node({
  baseType: Types.PRINT.CONTROL,
  nodeType: Generator.NODETYPE.PRINT
})



// WEBPACK FOOTER //
// ./src/reducers/root/print/control.js